'use client'

import Link from 'next/link'
import { ArrowRightIcon } from '@phosphor-icons/react'
import { HeroWordRotate } from './hero-word-rotate'

export function LandingPage() {
  return (
    <div className="surface-grain relative flex min-h-svh flex-col overflow-hidden">
      {/* Topographic background pattern — slow drift makes it breathe */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="landing-topo-drift h-full w-full">
          <svg
            className="absolute top-1/2 left-1/2 h-[120vh] w-[200vw] -translate-x-1/2 -translate-y-1/2 opacity-[0.04]"
            viewBox="0 0 1600 800"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid slice"
          >
            <path
              d="M-100 700 Q400 650 800 580 T1700 500"
              stroke="currentColor"
              strokeWidth="1"
              className="text-foreground"
            />
            <path
              d="M-100 600 Q400 540 800 460 T1700 380"
              stroke="currentColor"
              strokeWidth="1"
              className="text-foreground"
            />
            <path
              d="M-100 500 Q400 430 800 340 T1700 260"
              stroke="currentColor"
              strokeWidth="1"
              className="text-foreground"
            />
            <path
              d="M-100 400 Q400 320 800 220 T1700 140"
              stroke="currentColor"
              strokeWidth="1"
              className="text-foreground"
            />
            <path
              d="M-100 300 Q400 210 800 100 T1700 20"
              stroke="currentColor"
              strokeWidth="1"
              className="text-foreground"
            />
          </svg>
        </div>
      </div>

      {/* Header */}
      <header className="landing-entrance landing-entrance-1 relative z-10 flex items-center justify-between px-6 py-6 sm:px-8">
        <span className="font-logo text-foreground text-2xl tracking-tight">
          konstant<span className="text-brand-accent">out</span>
        </span>
        <Link
          href="/auth/login"
          className="text-muted-foreground hover:text-foreground focus-visible:outline-foreground rounded-md px-2 py-1 text-sm font-medium transition-colors focus-visible:outline-2 focus-visible:outline-offset-2"
        >
          Sign in
        </Link>
      </header>

      {/* Hero */}
      <main className="relative z-10 flex flex-1 flex-col items-center justify-center px-6">
        <div className="w-full text-center">
          <h1 className="landing-entrance landing-entrance-2 text-foreground mx-auto mb-6 text-xl leading-tight font-medium tracking-tight sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl">
            <HeroWordRotate
              prefix="Constantly"
              words={[
                'busy.',
                'overwhelmed.',
                'thinking.',
                'juggling.',
                'behind.',
              ]}
              renderFinal={() => (
                <span className="font-logo">
                  konstant
                  <span className="text-brand-accent accent-settle">out</span>.
                </span>
              )}
              interval={1500}
              firstPhraseDelay={2500}
              phraseClassName="text-muted-foreground"
            />
          </h1>

          <p className="landing-entrance landing-entrance-3 text-muted-foreground mx-auto mb-10 max-w-md text-lg sm:text-xl">
            Out of your head. Into your system.
          </p>

          <div className="landing-entrance landing-entrance-4">
            <Link
              href="/auth/sign-up"
              className="cta-lift group bg-foreground text-background focus-visible:outline-foreground inline-flex items-center gap-2 rounded-lg px-6 py-3 text-base font-medium focus-visible:outline-2 focus-visible:outline-offset-2"
            >
              Get started
              <ArrowRightIcon
                weight="bold"
                className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5"
              />
            </Link>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="landing-entrance landing-entrance-5 relative z-10 py-8 text-center">
        <p className="text-muted-foreground text-sm">Your mind, streamlined.</p>
      </footer>
    </div>
  )
}
